// Photo crops from the keepsake page frames (width / height).
export const CARD_IMAGE_RATIO = 373 / 280
export const MOBILE_IMAGE_RATIO = 382 / 300
export const STEP_IMAGE_RATIO = 270 / 184
export const STEP_MOBILE_IMAGE_RATIO = 382 / 260
